import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3b309cac&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3b309cac&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b309cac')) {
      api.createRecord('3b309cac', component.options)
    } else {
      api.reload('3b309cac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3b309cac&lang=pug", function () {
      api.rerender('3b309cac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dojo/upgradeTest/index.vue"
export default component.exports